import { propertyDraftQueryKeys as e } from "./propertyDraftQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { propertyDraftsApi as r } from "@maat/api-main";
//#region src/propertyDrafts/useUpdatePropertyDraftMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: ({ draftId: e, payload: t }) => r.updateDraft(e, t),
		onSuccess: (t, { draftId: n }) => {
			i.invalidateQueries({ queryKey: e.list() }), i.invalidateQueries({ queryKey: e.detail(n) });
		}
	});
};
//#endregion
export { i as useUpdatePropertyDraftMutation };
